// HC-7 effort signal — %HRmax. Pure, IO-free. JL EXPOSES the raw derived number
// (avg HR as a fraction of the age-predicted max); it does NOT interpret the
// zone or editorialize "hard vs easy" — that's the coach's job
// (next/health-connect-cgm.md §HC-7). Feeds the athlete health view (HC-8) and
// pairs with the calorie block. Age comes from the caller via `ageFromBucket`
// (Profile stores only an AgeBucket), so this module stays age-source-agnostic.

// The classic age-predicted max-HR anchor (220 − age). Coarse but standard;
// exposed raw so the coach can substitute a measured max later.
export const HR_MAX_ANCHOR = 220;

/** Age-predicted max HR (bpm), or null for a missing/implausible age. */
export const maxHr = (ageYears: number | undefined): number | null => {
  if (ageYears === undefined || !Number.isFinite(ageYears)) return null;
  if (ageYears <= 0 || ageYears > 120) return null;
  return HR_MAX_ANCHOR - ageYears;
};

/** avg-HR as a whole-number percentage of the age-predicted max, or null when
 *  either input is missing/implausible. Rounded — a calorie/effort readout never
 *  needs sub-percent precision. */
export const percentHrMax = (
  hrBpm: number | undefined,
  ageYears: number | undefined,
): number | null => {
  if (hrBpm === undefined || !Number.isFinite(hrBpm) || hrBpm <= 0) return null;
  const hm = maxHr(ageYears);
  if (hm === null || hm <= 0) return null;
  return Math.round((hrBpm / hm) * 100);
};
